import { Injectable } from "@angular/core";
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";

import { UiService } from "@services/ui.service";
import { GroupingService } from '@services/grouping.service';
import { GroupingLists } from '@classes/grouping/grouping-lists';


@Injectable()
export class GroupingResolver implements Resolve<GroupingLists> {
    constructor(
        private compareSrv: GroupingService,
        private uiSrv: UiService
    ) {}

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<GroupingLists> {
        this.uiSrv.routeLoadingStateChanged.next(true);

        return this.compareSrv.getList()
        .pipe(
            tap(() => {
                this.uiSrv.routeLoadingStateChanged.next(false);
            })
        );
    }
}
